import { useState } from "react";
import { newsItems as siteNewsItems } from "../data/news";
import { useStudio } from "../studio/StudioContext";

const formatNewsDate = (date) => {
  const [month, year] = (date || "").split(" ");
  if (!month || !year) return date;
  return (
    <span className="font-semibold text-gray-700 dark:text-gray-300">
      {`${year} ${month}:`}
    </span>
  );
};

const ITEM_CONTAINER_CLASSES = "flex flex-col gap-3 pb-3";

const NewsUpdates = ({ items: itemsProp } = {}) => {
  const INITIAL_COUNT = 5;
  const [showAll, setShowAll] = useState(false);
  const { studioMode, draft } = useStudio();
  // Only overlay draft while Visual edit is open — stale localStorage
  // otherwise silently overrides src/data/news.js.
  const filteredNews =
    itemsProp ||
    (studioMode && draft?.newsItems) ||
    siteNewsItems;

  const showableNews = showAll
    ? filteredNews
    : filteredNews.slice(0, INITIAL_COUNT);

  return (
    <div className={ITEM_CONTAINER_CLASSES}>
      <ul
        className={`list-disc space-y-1 pl-4 pr-2 text-sm leading-relaxed text-gray-700 dark:text-gray-300 custom-scrollbar ${
          !showAll && filteredNews.length > INITIAL_COUNT
            ? "max-h-[540px] overflow-y-auto"
            : ""
        }`}
      >
        {showableNews.length === 0 ? (
          <li className="text-gray-500 dark:text-gray-400 list-none -ml-4">
            No news.
          </li>
        ) : (
          showableNews.map((item, idx) => (
            <li key={idx}>
              {formatNewsDate(item.date)} {item.title}
              {item.links?.slides ? (
                <>
                  {" "}
                  <a
                    href={item.links.slides}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green dark:text-green-dark underline underline-offset-2"
                  >
                    Slides
                  </a>
                </>
              ) : null}
            </li>
          ))
        )}
      </ul>
      {!showAll && filteredNews.length > INITIAL_COUNT && (
        <div className="mt-6 text-center">
          <button
            onClick={() => setShowAll(true)}
            className="text-sm font-medium text-green dark:text-green-dark underline underline-offset-2"
          >
            See more
          </button>
        </div>
      )}
      {showAll && filteredNews.length > INITIAL_COUNT && (
        <div className="mt-6 text-center">
          <button
            onClick={() => setShowAll(false)}
            className="text-sm font-medium text-green dark:text-green-dark underline underline-offset-2"
          >
            See less
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsUpdates;
